import Component from "react-pure-render/component";
import React from "react";
import Isvg from "react-inlinesvg";
import moment from "moment";
import Griddle from "griddle-react";
import Tooltip from "rc-tooltip";
import Modal from "../components/modal.react";

import { addNotificationsForInvalidFields } from "../lib/validationWeb";

class ActionComponent extends Component {
  openRemoveSubmissionModal = () => {
    const {
      openRemoveSubmissionModal
    } = this.props.metadata.customComponentMetadata;
    const { uid } = this.props.rowData;
    openRemoveSubmissionModal(uid);
  };
  render() {
    return (
      <div>
        <Tooltip
          placement="bottom"
          trigger={["click", "hover"]}
          overlay={
            <div className="popover">
              <a onTouchTap={this.openRemoveSubmissionModal}>usuń</a>
            </div>
          }
          getTooltipContainer={() => document.getElementById("wrapper")}
        >
          <div className="icon-table link" />
        </Tooltip>
      </div>
    );
  }
}

class DateComponent extends Component {
  render() {
    const data = moment(new Date(this.props.data)).format("DD.MM.YYYY HH:mm");
    return <span>{data}</span>;
  }
}

class ContentComponent extends Component {
  render() {
    return <span />;
  }
}

export default class Table extends Component {
  static propTypes = {
    actions: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
  }

  closeRemoveFormSubmissionModal = () => {
    const { actions } = this.props;
    actions.setIsRemoveFormSubmissionModalVisible(false);
  };

  openRemoveSubmissionModal = uid => {
    const { actions } = this.props;
    actions.setIsRemoveFormSubmissionModalVisible(uid);
  };

  removeFormSubmission = () => {
    const {
      actions,
      notificationSystem,
      formSubmissions: {
        formSubmissions: {
          isRemoveModalVisible,
          meta: formSubmissionsMeta,
          sort: formSubmissionsSort
        }
      }
    } = this.props;
    actions
      .removeFormSubmission(isRemoveModalVisible)
      .then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        } else {
          actions
            .getFormSubmissions(formSubmissionsMeta, formSubmissionsSort)
            .then(({ error, payload }) => {
              if (error) {
                addNotificationsForInvalidFields(payload, notificationSystem);
              }
            });
        }
      });
    actions.setIsRemoveFormSubmissionModalVisible(false);
  };

  onRowClick = (row, e) => {
    if (e.target.className !== "icon-table link") {
      const { history } = this.props;
      history.pushState(
        "/form-submissions/:uid",
        `/form-submissions/${row.props.data.uid}`,
        {}
      );
    }
  };

  onChangeSort = field => {
    if (field === "name") {
      const {
        actions,
        notificationSystem,
        formSubmissions: {
          formSubmissions: {
            search: formSubmissionsSearch,
            meta: formSubmissionsMeta,
            sort: formSubmissionsSort
          }
        }
      } = this.props;
      if (field === "when") {
        field = "whenOccured";
      }
      actions.setFormSubmissionsPaginationPage(0);
      let isDirectionAscending = formSubmissionsSort.isDirectionAscending;
      if (field === formSubmissionsSort.field) {
        isDirectionAscending = !isDirectionAscending;
      }
      actions.setSortFormSubmissions(field, isDirectionAscending);
      actions
        .getFormSubmissions(formSubmissionsMeta, formSubmissionsSort)
        .then(({ error, payload }) => {
          if (error) {
            addNotificationsForInvalidFields(payload, notificationSystem);
          }
        });
    }
  };

  render() {
    const {
      config,
      actions,
      tableWidth,
      tableHeight,
      formSubmissions: {
        formSubmissions: {
          isRemoveModalVisible,
          loading,
          entities: formSubmissions,
          meta: { currentPage, limit },
          sort
        }
      }
    } = this.props;

    let columnMetadata = [
      {
        columnName: "index",
        displayName: "Lp.",
        cssClassName: "table-unsortable",
        visible: true
      },
      {
        columnName: "name",
        displayName: "Nazwa formularza",
        cssClassName: "table-unsortable",
        visible: true
      },
      {
        columnName: "createdAt",
        displayName: "Data wysłania wiadomości",
        cssClassName: "table-unsortable",
        visible: true,
        customComponent: DateComponent
      },
      {
        columnName: "actions",
        displayName: "Akcje",
        visible: true,
        cssClassName: "data-table-file table-unsortable",
        customComponent: ActionComponent,
        customComponentMetadata: {
          openRemoveSubmissionModal: this.openRemoveSubmissionModal
        }
      }
    ];

    let data = [];
    let index = 0;

    if (formSubmissions) {
      formSubmissions.forEach(function(formSubmission) {
        formSubmission = formSubmission.toJS();
        index++;
        formSubmission.index = index + currentPage * limit;
        data = data.concat(formSubmission);
      });
    }

    return (
      <div>
        <Griddle
          results={data}
          columnMetadata={columnMetadata}
          tableClassName="data-table"
          useGriddleStyles={false}
          columns={["index", "name", "createdAt", "actions"]}
          onRowClick={this.onRowClick}
          enableSort={false}
          enableInfiniteScroll={false}
          showPager={false}
          bodyHeight={tableHeight}
          resultsPerPage={100}
          useExternal={true}
          externalChangeSort={this.onChangeSort}
          externalSortColumn={sort.field}
          externalSortAscending={sort.isDirectionAscending}
          externalSetPage={() => {}}
          externalSetFilter={() => {}}
          externalSetPageSize={() => {}}
          externalMaxPage={() => {}}
          externalCurrentPage={() => {}}
          noDataMessage={loading ? "trwa ładowanie danych..." : "Brak danych"}
          sortAscendingComponent={
            <Isvg className="fa fa-sort-asc" src="/assets/img/icon_sort.svg" />
          }
          sortDescendingComponent={
            <Isvg className="fa fa-sort-desc" src="/assets/img/icon_sort.svg" />
          }
        />

        {isRemoveModalVisible && (
          <Modal
            closeModalAction={this.closeRemoveFormSubmissionModal}
            enterAction={this.removeFormSubmission}
            handleKeyDownEvent={true}
          >
            <div className="row">
              <h3 className="col-xs-12">Potwierdź usunięcie</h3>
              <div className="col-xs-12">
                <p>Czy napewno usunąć?</p>
                <button className="error" onClick={this.removeFormSubmission}>
                  Usuń
                </button>
              </div>
            </div>
          </Modal>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/formSubmissions/table.react.js